import { setAutocompleteOnAddresses } from './application';
import { bindDobInputs, displayErrorMessage, handleAddEventSmartlook, saveApplication as saveGeneralApplication } from './common'
import { APPLICATION_SUPPLIER_ACCREDITATION } from './constants';
import {
  SUPPLIER_ACCREDITATION_BUSINESS_RULES,
  SUPPLIER_ACCREDITATION_PERSONAL_RULES,
  SUPPLIER_ACCREDITATION_INSTALLERS_RULES,
  SUPPLIER_ACCREDITATION_EXPERIENCE_RULES,
  SUPPLIER_ACCREDITATION_LOGIN_RULES,
  SUPPLIER_ACCREDITATION_ACKNOWLEDGEMENT_RULES
} from './rules'
import { validate } from './validate';

let startTimeCreateCommercialStep = 0;

window.sfDocumentReady(['route-supplier-accreditation-edit'], () => {
  handleAddEventSmartlook('New Application', APPLICATION_SUPPLIER_ACCREDITATION);
  handleSaveApplication();
  handleAddOtherGroupInput('js-add-other-installer', 'installer-item-container')
  handleAddOtherGroupInput('js-add-other-login', 'login-item-container')
  handleShowExperienceReference()
  handleShowAcknowledgementDescription()
  runReview()
  submitApplication()

  // Review Page edit link, trigger click to sidebar step wizard
  $('.edit-stage-link').click(function () {
    const section = $(this).attr('href');
    $('.stepwizard-step')
      .children(`a[href="${section}"]`)
      .trigger('click');
  });

  $('.stepwizard-step')
    .children('a')
    .on('click', async () => {
      startTimeCreateCommercialStep = Date.now();
    })
});

const saveApplication = ($button, dataForm = null) => {
  if ($('.application_id').val()) {
    if (!dataForm) {
      const $form = $button.closest('form');
      if (isDirty($form) && !confirmPrivacyNullification()) {
        $form.trigger('reset');
        return;
      }
      dataForm = $form.serializeArray();
    }
    const $curStep = $button.closest('.setup-content');
    const curStepBtn = $curStep.attr('data-stage');
    const navItem = $(`.setup-panel div a[href="#${curStepBtn}"]`).parent();
    const nextStepWizard = navItem.next().children('a');
    return new Promise((resolve, reject) => {
      saveGeneralApplication(dataForm, {
        success(data) {
          $('.js-display-errors').html('');
          if (data.status === 'success') {
            navItem.addClass('step-complete');
            if ($button.hasClass('continueAfterSaving')) {
              nextStepWizard.trigger('click');
            } else {
              // redirect to listing on save & exit
              window.location.href = '/';
            }
            $('html, body').animate(
              {
                scrollTop: 0
              },
              100
            );
          }
          $('html, body').animate(
            {
              scrollTop: 0
            },
            100
          );
          resolve(data);
        },
        error(response, status, error) {
          if (response.responseJSON && response.responseJSON.errors) {
            const errors = response.responseJSON.errors;
            displayErrorMessage($button, errors, response.status)
          } else {
            notifyBox('Error', 'An unexpected error occurred. Please try again', 'error');
          }
          if (ajaxErrorHandler(response.status)) {
            return;
          }
          navItem.removeClass('step-complete');
        }
      })
    });
  } else {
    notifyBox(
      'Unable to save',
      'Please fill basic information first',
      'error'
    );
  }
}

function changeNameOfInput($container, newIndex) {
  $container.find('input, textarea, select').each(function (index) {
    const name = $(this).attr('name');
    const newName = name.replace(/\d+/, newIndex);
    const indexId = newIndex + index
    $(this)
      .attr('name', newName)
      .attr('id', `${newName}_${indexId}`)
      .prop('checked', false)
      .siblings('label')
      .attr('for', `${newName}_${indexId}`);
    if (!$(this).hasClass('js-no-change-value')) {
      $(this).val('')
    }

    const oldClassError = name.replace(/\[|\]|]\[|]$/g, (match) => {
      if (match === '[') return '_';
      if (match === ']') return '';
    }) + '-err'
    const newClassError = newName.replace(/\[|\]|]\[|]$/g, (match) => {
      if (match === '[') return '_';
      if (match === ']') return '';
    }) + '-err'

    const $messageError = $(this).closest('.ffl-wrapper').find('.js-display-errors');
    $messageError.removeClass(oldClassError).addClass(newClassError);
  });

  $container.find('.ffl-wrapper').floatingFormLabels({
    formElements: 'input, textarea, select'
  });

  return $container;
}

function handleAddPersonals(applicantCount) {
  const currentApplicant = $('.personal-container').length;

  if (applicantCount > currentApplicant) {
    for (let i = currentApplicant; i < applicantCount; i++) {
      const $lastPersonal = $('.personal-container').last();
      let $personalCloned = $lastPersonal.clone(false);
      const newIndex = Date.now() + i;
      $personalCloned = changeNameOfInput($personalCloned, newIndex)
      $personalCloned.insertAfter('.personal-container:last');
      $personalCloned.find('.js-display-errors').html('');
    }
  } else {
    $('.personal-container').slice(applicantCount).remove();
  }
  reNumberOfPersonas(applicantCount);
  setAutocompleteOnAddresses();
  bindDobInputs();

  function reNumberOfPersonas(applicantCount) {
    const $personalContainer = $('.personal-container');
    const
      APPLICANT_TYPE_INDIVIDUAL = 1,
      APPLICANT_TYPE_PARTNERSHIP = 2,
      APPLICANT_TYPE_COMPANY = 3,
      APPLICANT_TYPE_TRUST = 4;
    const applicantType = parseInt($('#applicant_type').val());
    let title = 'Director Details';
    if (applicantType === APPLICANT_TYPE_INDIVIDUAL)
      title = 'Sole Trader Details';
    else if (applicantType === APPLICANT_TYPE_PARTNERSHIP)
      title = 'Partner Details';
    $personalContainer.each(function (index) {
      $(this).find('.personal-title h2 b').html(title);
      $(this).find('.personal-title .total-of').html(`${index + 1} of ${applicantCount}`);
    });
  }
}

function handleAddOtherGroupInput(idSelector, groupItemClass) {
  removeInformation();
  $(`#${idSelector}`).on('click', function () {
    const $form = $(this).closest('form')
    const $lastGroup = $(`.${groupItemClass}`, $form).last();
    let $groupCloned = $lastGroup.clone(false);
    const newIndex = Date.now();
    $groupCloned = changeNameOfInput($groupCloned, newIndex);
    $groupCloned.find('.js-remove-wrapper').removeClass('collapse');
    $groupCloned.insertAfter($form.find(`.${groupItemClass}:last`));
    $groupCloned.find('.js-display-errors').html('');
    removeInformation();
  })
}

function removeInformation() {
  $('.js-remove-wrapper .remove-item').on('click', function() {
    $(this).closest(`.item-container`).remove();
  })
}

function saveSupplierBusiness($button, $form) {
  const rules = SUPPLIER_ACCREDITATION_BUSINESS_RULES
  if ($('#applicant_type').val() === '4') {
    rules['acn_number'] = {
      required: {
        value: true, message: 'Required'
      },
      maxLength: {
        value: 9, message: 'ACN must be 9 digits'
      },
      minLength: {
        value: 9, message: 'ACN must be 9 digits'
      }
    }
  }
  const dataForm = $form.serializeArray();
  const isValid = validate(dataForm, $form, rules)
  if (!isValid) return
  saveApplication($button, dataForm).then(res => {
    const { gst_status_at, applicants_count } = res.data.data.application
    handleAddPersonals(applicants_count)
    const [day, month, year] = gst_status_at.split("-");
    const formattedDate = `${year}-${month}-${day}`;
    $('#gst_status_at').val(formattedDate);
    handleShowExperienceReference();
    handleAddEventSmartlook('Step business', APPLICATION_SUPPLIER_ACCREDITATION, startTimeCreateCommercialStep);
  });
}

function isLessThanTwoYears(time) {
  const twoYearsInMilliseconds = 2 * 365 * 24 * 60 * 60 * 1000;
  return Date.parse(time) + twoYearsInMilliseconds > Date.now();
}

function handleShowExperienceReference() {
  if (isLessThanTwoYears($('#gst_status_at').val())) {
    $('.js-experience-reference').show()
  } else {
    $('.js-experience-reference').hide()
  }
}

function handleShowAcknowledgementDescription() {
  $('.js-acknowledgement-description').each(function () {
    const $descriptionItem = $(this);
    const $acknowledgementContainer = $descriptionItem.closest('.acknowledgement-item-container');
    const $statusButtons = $acknowledgementContainer.find('.status');

    $statusButtons.on('change', function () {
      $descriptionItem.toggle($(this).hasClass('status-yes'));
    });

    $descriptionItem.toggle($statusButtons.filter(':checked').hasClass('status-yes'));
  });
}

function handleSaveData($button, $form, rules, dataKeys, idSelectors) {
  const dataForm = $form.serializeArray();
  const isValid = validate(dataForm, $form, rules);
  if (!isValid) return;
  return saveApplication($button, dataForm).then(res => {
    if (res.status === 'success') {
      dataKeys.forEach((dataKey, index) => {
        const { [dataKey]: itemIds } = res.data.data;
        $form.find('.js-display-errors').html('');
        $form.find(idSelectors[index]).each(function (index) {
          $(this).val(itemIds[index]);
        });
      });
    }
  });
}

function handleSavePersonals($button, $form) {
  handleSaveData($button, $form, SUPPLIER_ACCREDITATION_PERSONAL_RULES, ['individualIds'], ['.personal-container .applicant_id']).then(() => {
    handleAddEventSmartlook('Step personal', APPLICATION_SUPPLIER_ACCREDITATION, startTimeCreateCommercialStep);
  });
}

function handleSaveInstallers($button, $form) {
  handleSaveData($button, $form, SUPPLIER_ACCREDITATION_INSTALLERS_RULES, ['installerIds'], ['.installer-item-container .installer_id']).then(() => {
    handleAddEventSmartlook('Step installers', APPLICATION_SUPPLIER_ACCREDITATION, startTimeCreateCommercialStep);
  });
}

function handleSaveExperience($button, $form) {
  const rules = SUPPLIER_ACCREDITATION_EXPERIENCE_RULES
  if (isLessThanTwoYears($('#gst_status_at').val())) {
    rules['full_name'] = {
      required: {
        value: true, message: 'Required'
      },
    }
    rules['phone_number'] = {
      required: {
        value: true, message: 'Required'
      },
    }
    rules['description'] = {
      required: {
        value: true, message: 'Required'
      },
    }
  }
  handleSaveData($button, $form, rules, ['experienceIds', 'experienceInfoIds'], ['.experience-item-container .experience_id', '.js-experience-reference .experience_info_id']).then(() => {
    handleAddEventSmartlook('Step experience', APPLICATION_SUPPLIER_ACCREDITATION, startTimeCreateCommercialStep);
  });
}

function handleSaveLoginInfo($button, $form) {
  handleSaveData($button, $form, SUPPLIER_ACCREDITATION_LOGIN_RULES, ['loginIds'], ['.login-item-container .login_info_id']).then(() => {
    handleAddEventSmartlook('Step login', APPLICATION_SUPPLIER_ACCREDITATION, startTimeCreateCommercialStep);
  });
}

function handleSaveAcknowledgement($button, $form) {
  handleSaveData($button, $form, SUPPLIER_ACCREDITATION_ACKNOWLEDGEMENT_RULES, ['acknowledgementIds'], ['.acknowledgement-item-container .acknowledgement_id']).then(() => {
    handleAddEventSmartlook('Step acknowledgement', APPLICATION_SUPPLIER_ACCREDITATION, startTimeCreateCommercialStep);
  });
}

function handleSaveApplication() {
  $(document).on('click', '.btn-save-supplier', function () {
    const $form = $(this).closest('form');
    const stage = $form.find('input[name=stage]').val();

    const saveHandlers = {
      'business': saveSupplierBusiness,
      'personal': handleSavePersonals,
      'installers': handleSaveInstallers,
      'experience': handleSaveExperience,
      'login': handleSaveLoginInfo,
      'acknowledgement': handleSaveAcknowledgement
    };

    const saveHandler = saveHandlers[stage];
    if (saveHandler) {
      saveHandler($(this), $form);
    }
  });
}

function runReview() {
  startReview();
  $('.stepwizard-step.review')
    .children('a')
    .on('click', async () => {
      startReview();
    });
}

async function startReview() {
  const applicationId = $('.application_id').val()
  if (!applicationId) return false;
  await window.httpGet(`/supplier-accreditation/review/${applicationId}`, null, {
    success(response) {
      if (!response.data) {
        return;
      }
      const data = response.data;
      checkValidationReview(data)
      if (data.application.privacy_consent_type) {
        $('#consent-form-container').hide();
      }
    },
    error(response, status, error) {
      $('.submitSupplierApplication').prop('disabled', true);
      if (ajaxErrorHandler(response.status)) {
        return;
      }
      notifyBox(
        'Error',
        'Please check that all steps of the application are complete before reviewing the application.',
        'error'
      );
    }
  });
}

function renderDescriptionBusinessStage(element, application) {
  const content = `
    <div class="row sf-mb-3">
      <div class="col-md-12">${application.business_name}, ${application.business_location}</div>
    </div>`
  $(`#${element}`).find('.description-stage').html(content);
}

function renderDescriptionPersonalStage(element, applicants) {
  let content = ``
  applicants.forEach((individual, index) => {
    const fullName = `${individual.first_name.trim()} ${individual.middle_name.trim()} ${individual.last_name.trim()}`;
    content += `
      <div class="row col-md-12 sf-mb-3 sf-flex">
        <div class="">${index + 1}. </div>
        <div>
          <div class="col-md-12">${fullName}</div>
          <div class="col-md-12">${individual.location}</div>
          <div class="col-md-12 sf-p-0">
            <div class="col-md-6">${individual.email}</div>
            <div class="col-md-6">${JSON.parse(individual.mobile)[0].work_phone}</div>
          </div>
        </div>
      </div>
      `
  });
  $(`#${element}`).find('.description-stage').html(content);
}

function renderDescriptionInstallertage(element, installers) {
  const InstallationsInHouse = installers.filter(item => item.installer_type === 1);
  const Installationssubcontracted = installers.filter(item => item.installer_type === 2);
  const content = `Installations completed by ${InstallationsInHouse.length} and ${Installationssubcontracted.length} subcontracted CEC installers`
  $(`#${element}`).find('.description-stage').html(content);
}

function renderDescriptionExperienceStage(element, experiences, experienceInfos) {
  const experienceResidential = experiences.filter(item => item.installation_type === 1)
  const experienceCommercial = experiences.filter(item => item.installation_type === 2)
  let content = `
  <div>${experienceResidential.length} residential and ${experienceCommercial.length} commercial installations completed in the last 12 months.</div>`
  if (experienceInfos.length > 0) {
    content += `<div>${experienceInfos[0].full_name} as reference (${experienceInfos[0].phone_number})</div>`
  }
  $(`#${element}`).find('.description-stage').html(content);
}

function renderDescriptionLoginStage(element, loginInfos) {
  let content = ``
  loginInfos.forEach((login, index) => {
    content += `
      <div class="row col-md-12 sf-mb-3 sf-flex">
        <div class="">${index + 1}. </div>
        <div>
          <div class="col-md-12">${login.full_name}</div>
          <div class="col-md-12 sf-p-0">
            <div class="col-md-6">${login.email}</div>
            <div class="col-md-6">${login.phone_number}</div>
          </div>
        </div>
      </div>
      `
  });
  $(`#${element}`).find('.description-stage').html(content);
}


function checkValidationReview(data) {
  const imgComplete = '/images/icons/check-circle-1.svg';
  const imgIncomplete = '/images/icons/alert-circle.svg';
  let completeAll = true;
  $.each(data.validation, (key, value) => {
    if (value.status === 'success') {
      $(`#${key}`).find('.status').html('Complete');
      $(`#${key}`).find('.review-image .image').html(
        `<img src="${imgComplete}" class="image" height="20">`
      );
      switch (key) {
        case 'resStage_business':
          renderDescriptionBusinessStage(key, data.application);
          break;
        case 'resStage_personal':
          renderDescriptionPersonalStage(key, data.application.applicants);
          break;
        case 'resStage_installers':
          renderDescriptionInstallertage(key, data.application.installers);
          break;
        case 'resStage_experience':
          renderDescriptionExperienceStage(key, data.application.experiences, data.application.experience_infos);
          break;
        case 'resStage_login':
          renderDescriptionLoginStage(key, data.application.logins);
          break;
        case 'resStage_acknowledgement':
          $(`#${key}`).find('.description-stage').html('You have acknowledged and consented to the terms of accreditation and your application is ready for review.');
          break;
        default:
          break;
      }
      $(`#${key}`).find('.edit-stage-link').html('Edit');
      $(`#${key}`).find('.edit-stage-link').removeClass('button btn btn-submit');
    } else {
      $(`#${key}`).find('.status').html('Incomplete');
      $(`#${key}`).find('.review-image .image').html(
        `<img src="${imgIncomplete}" class="image" height="20">`
      );
      $(`#${key}`).find('.description-stage').html(value.msg);
      $(`#${key}`).find('.edit-stage-link').addClass('button btn btn-submit');
      $(`#${key}`).find('.edit-stage-link').html('Complete this step');
      if (key !== 'resStage_review') {
        completeAll = false;
      }
    }
  });
  if (!completeAll) {
    $('#resStage_review').find('.description-stage').html("Please complete all the above steps before submit.");
    $('.submitSupplierApplication').prop('disabled', true);
  } else {
    $('.submitSupplierApplication').prop('disabled', false);
    if (data.application.privacy_consent_verified === 1) {
      $('#stepwizard-review').addClass('step-complete')
    }
  }
  $('#resStage_review').hide()
}

function submitApplication() {
  $('.submitSupplierApplication').on('click', function () {
    const $button = $(this);
    const previouslySubmittedInput = $('input[name="previously_submitted"]');
    if (previouslySubmittedInput.val() === '1') {
      const message = 'Making changes after the application has been submitted will require a new privacy consent to be sent out. Would you like to continue with the above changes?';
      if (!confirm(message)) {
        return false;
      }
    }

    const data = {
      application_id: $('.application_id').val()
    };

    window.httpPost('/supplier-accreditation', data, {
      success(response) {
        if (response.status === 'success') {
          handleAddEventSmartlook('completed application', APPLICATION_SUPPLIER_ACCREDITATION, startTimeCreateCommercialStep);
          notifyBox('', 'An email has been sent to each applicant.', 'success');
          $('input[name="previously_submitted"]').val(1);
          $button.html('Resend');
          $button.closest('.ApplicationWizard').hide();
          $('#statusBlock').show();
        }
      },
      error(response, status, error) {
        if (ajaxErrorHandler(response.status)) {
          return;
        }
        notifyBox('Error', 'Error occurred', 'error');
      }
    });
  });
}
